import { Badge } from "@kyan/ui";

import { type RFQResponseState } from "#/services/kyan/kyan.types";
import { useAccount } from "#/store/wallet/account/account";
import { isEqualAddress } from "#/utils/isEqualAddress";
import { flipDirection } from "#/utils/marketActionConverter";

export interface RfqDirectionProps {
  response: RFQResponseState;
}

export const RfqDirection: React.FC<RfqDirectionProps> = ({ response }) => {
  const { account } = useAccount();

  const isTaker = isEqualAddress(account, response.taker);

  const direction = response.legs[0].direction;
  if (!direction) return null;

  const shownDirection = isTaker ? flipDirection(direction) : direction;

  return (
    <Badge className="capitalize" variant={shownDirection}>
      {shownDirection}
    </Badge>
  );
};
